
import AboutMe from './componnents/AboutMe';
import Footer from './componnents/Footer';
import Gallery from './componnents/Gallery';
import MenuShowcase from './componnents/MenuShowcase';
import Navbar from './componnents/Navbar';
import { Routes, Route } from "react-router-dom";
import { useTranslation} from "react-i18next"

import { useEffect } from 'react';
import EventServices from './componnents/Events';
function App() {

  const {i18n} = useTranslation();
  useEffect(() => {
        const userLang = navigator.language;
        i18n.changeLanguage(userLang.startsWith("he") ? "he" : "en");
      }, []);
  const { t } = useTranslation();
  const bgStyle = {
    margin: 0,
    padding: 0,
    backgroundColor:"#fff8dc",
    backgroundSize: "cover",
    backgroundPosition: "center top",
    backgroundRepeat: "no-repeat",
    backgroundAttachment: "fixed",
    minHeight: "100vh",
    width: "100%",
    height: "auto"
  };
  return (
    <div style={bgStyle}>
      <header className="App-header">
        <Navbar></Navbar>
           <h1 className="text-center fw-bold" style={{color:"blue"}}>{t("israel_kitchen")}</h1>
      </header> 
        <Routes>
          <Route path="/" element={<MenuShowcase />} />
          <Route path="/about" element={<AboutMe />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/events" element={<EventServices />} />
        </Routes>
    

      <Footer></Footer>
    </div>
  );
}

export default App;
